import useThemeStore from "src/store/themeStore";

/** The global theme flag and its toggle. <body>'s dark-theme class is kept in
 *  sync by the store itself (see themeStore.ts), so this hook only reads. */
export function useDarkTheme() {
  const isDarkTheme = useThemeStore((state) => state.isDarkTheme);
  const toggleDarkTheme = useThemeStore((state) => state.toggleDarkTheme);

  return { isDarkTheme, toggleDarkTheme };
}
